const o = ["#EF5771"], _ = [...o, "#EBC700"], t = [..._, "#DB3A00"], A = [..._, "#C2E10E", t[2]];
export {
  o as POI_2_TA1,
  _ as POI_2_TA2,
  t as POI_2_TA3,
  A as POI_2_TA4
};
//# sourceMappingURL=index.es5715.js.map
